import { BlogPost } from '@/src/domain/models/BlogPost';
import { post as leaguesPost } from './2026-02-08-leagues';
import { post as howToOrganizePost } from './2026-04-02-how-to-organize-a-tournament';
import { post as pushNotificationsPost } from './2026-02-10-push-notifications';
import { post as invitationsPost } from './2026-02-12-tournament-invitations';
import { post as proPost } from './2026-02-17-tournaly-pro';
import { post as kothPost } from './2026-03-03-king-of-the-hill';
import { post as dashboardPost } from './2026-03-03-home-dashboard';
import { post as teamsPost } from './2026-03-05-teams';
import { post as roundRobinPost } from './2026-03-06-round-robin-tournament-guide';
import { post as doubleEliminationPost } from './2026-03-06-double-elimination-bracket-guide';
import { post as singleVsDoublePost } from './2026-03-06-single-vs-double-elimination';
import { post as swissPost } from './2026-03-06-swiss-system-tournament-guide';
import { post as bracketMakerPost } from './2026-03-06-tournament-bracket-maker';
import { post as roundRobinVsEliminationPost } from './2026-04-20-round-robin-vs-elimination';
import { post as howToSeedPost } from './2026-05-19-how-to-seed-a-tournament-bracket';
import { post as groupStageKnockoutPost } from './2026-06-29-group-stage-knockout-tournament-guide';

const ALL_POSTS: BlogPost[] = [
  groupStageKnockoutPost,
  howToSeedPost,
  roundRobinVsEliminationPost,
  leaguesPost,
  howToOrganizePost,
  pushNotificationsPost,
  invitationsPost,
  proPost,
  kothPost,
  dashboardPost,
  teamsPost,
  roundRobinPost,
  doubleEliminationPost,
  singleVsDoublePost,
  swissPost,
  bracketMakerPost,
];

// Sorted descending by date (ISO 8601 sorts lexicographically)
export const blogPosts: BlogPost[] = [...ALL_POSTS].sort(
  (a, b) => b.date.localeCompare(a.date),
);

export function getPostBySlug(slug: string): BlogPost | undefined {
  return blogPosts.find((p) => p.slug === slug);
}
